import React, { createContext, useCallback, useState } from 'react';
import axios from 'axios';
import { wrap } from '@hilma/tools';

import { Area, Localize, StationResponse } from '../types';

export const StationsContext = createContext<StationResponse[] | null>(null);
export const AreasContext = createContext<Localize<Area>[] | undefined | null>(null);
export const StationsErrorContext = createContext<boolean | null>(null);
export const GetStationsAndAreasContext = createContext<(() => Promise<void>) | null>(null);

const StationsProvider: React.FC = ({ children }) => {
	const [areas, setAreas] = useState<Localize<Area>[]>();
	const [stations, setStations] = useState<StationResponse[]>([]);
	const [stationsError, setStationsError] = useState(false);

	const getStationsAndAreas = useCallback(async () => {
		try {
			if (areas || stationsError) return;
			const { data } = await axios.get<{ areas: Localize<Area>[]; stations: StationResponse[]; }>('/api/station');
			setAreas(data.areas);
			setStations(data.stations);
		} catch (error) {
			console.error(error);
			setStationsError(true);
			setAreas([]);
		}
	}, [areas, stations, stationsError]);

	return wrap(
		[StationsContext.Provider, { value: stations }],
		[AreasContext.Provider, { value: areas }],
		[StationsErrorContext.Provider, { value: stationsError }],
		[GetStationsAndAreasContext.Provider, { value: getStationsAndAreas }],
	)(children) as React.ReactElement;
}

export default StationsProvider;